module.exports = __webpack_public_path__ + "img/challenge-background-img.c68b66b5.png";